import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { problems } from '../data/content';
export function Problems() {
  return <section className="w-full border-t border-navy/10 bg-white px-5 py-20 sm:px-8" data-id="element-173" data-mp="36xuakwomj5m9">
      <div className="mx-auto w-full max-w-5xl" data-id="element-174" data-mp="3237z6tijld26">
        <Reveal data-id="element-175" data-mp="2y3z51njlbd63">
          <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-176" data-mp="2y2eba053ny9a">
            If you coach cheer, you're probably living{' '}
            <span className="text-cheer" data-id="element-177" data-mp="2o48d9tmezc9p">one of these problems</span>.
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-178" data-mp="2j6yc5gpnxc61">
          {problems.map((problem, index) => <Reveal key={problem} delay={index % 2 * 0.05} className="h-full" data-id="element-179" data-mp="2f5wjjiq93yd1" data-mpi={index}>
              <li className="flex h-full items-start gap-3 rounded-card border border-navy/10 bg-blush px-5 py-5 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-180" data-mp="hdsbw8ij86ha">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cheer/10" data-id="element-181" data-mp="34qbu3t7jbci2">
                  <XIcon className="h-3.5 w-3.5 text-cheer" aria-hidden="true" data-id="element-182" data-mp="39qzi060gvd82" />
                </span>
                <span className="text-[15px] font-semibold leading-snug text-navy" data-id="element-183" data-mp="2vr88ahgzgizv">
                  {problem}
                </span>
              </li>
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} data-id="element-184" data-mp="3nie3cjhujqia">
          <p className="mt-14 text-center font-display text-2xl font-extrabold leading-tight tracking-tight text-cheer sm:text-3xl" data-id="element-185" data-mp="3ni4kdfv7yjm3">
            How many more seasons do you want to keep improvising?
          </p>
        </Reveal>
      </div>
    </section>;
}